import { Link } from "react-router-dom";
import { Heart } from "lucide-react";

const DonatePage = () => {
  return (
    <div data-testid="donate-page" className="pt-16 md:pt-20">
      {/* Hero */}
      <section className="py-16 md:py-24 bg-[#002B7F]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl font-black tracking-tighter text-white mb-4">
            Support the Campaign
          </h1>
          <p className="text-lg text-white/80 max-w-2xl mx-auto">
            Your contribution helps us fight for every Nevada family. Together, we can build a state where everyone can thrive.
          </p>
        </div>
      </section>

      {/* Coming Soon */}
      <section className="py-24 md:py-32 bg-[#F8F9FA]">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="w-20 h-20 mx-auto mb-8 flex items-center justify-center bg-[#002B7F]/10">
            <Heart className="w-10 h-10 text-[#002B7F]" />
          </div>
          <h2 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900 mb-6">
            Coming Soon
          </h2>
          <p className="text-lg text-slate-600 leading-relaxed mb-8">
            Online donations will be available soon. In the meantime, please reach out to us directly if you'd like to support the campaign.
          </p>
          <Link
            to="/contact"
            data-testid="donate-contact-btn"
            className="inline-flex items-center gap-2 px-8 py-4 bg-[#002B7F] hover:bg-[#001F5C] text-white font-bold uppercase tracking-widest text-sm transition-all hover:-translate-y-1 hover:shadow-xl"
          >
            Contact Us
          </Link>
        </div>
      </section>
    </div>
  );
};

export default DonatePage;
